<div class="marketplace">
    <!-- <div class="marketplace-banner">
        <div class="banner-title">Marketplace</div>
        <div>
            Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna.
            Pellentesque sit amet sapien.
        </div>
    </div> -->
    <div class="products-container">
        <form [formGroup]="form">
            <div class="main-block">
                <div class="header-block-top">
                    <div
                        class="available-items"
                        [ngClass]="{ hidden: this.mobileSearch }">
                        Available Items: <span>{{ totalRecords }}</span>
                    </div>

                    <div
                        class="search-holder"
                        [ngClass]="{ hidden: !this.mobileSearch }">
                        <input
                            class="search-input"
                            [placeholder]="'Search...'"
                            formControlName="search" />
                    </div>
                    <div
                        class="mobile-search-btn"
                        [ngClass]="{ active: this.mobileSearch }"
                        (click)="toggleMobileSearch()">
                        &nbsp;
                    </div>
                </div>
                <div class="header-filter-search">
                    <div
                        class="filters-btn"
                        (click)="openFilters()">
                        <svg-icon
                            src="assets/images/marketplace/icon-filters.svg"
                            [svgClass]="'product-filters-icon'"></svg-icon>
                        Filters
                    </div>
                    <div class="header-sort">
                        <span>Sort By:</span>
                        <ng-select
                            class="styled-select"
                            [clearable]="false"
                            [searchable]="false"
                            formControlName="sort"
                            [placeholder]="'Please select'">
                            <ng-option
                                *ngFor="let st of sortTypes"
                                [value]="st.val"
                                >{{ st.name }}</ng-option
                            >
                        </ng-select>
                    </div>
                </div>
                <div class="product-tiles">
                    <div
                        class="product-tile"
                        (click)="openProductDetails(product.slug)"
                        *ngFor="let product of products">
                        <div
                            class="title-image-holder"
                            [ngStyle]="{'background-image': 'url(' + product?.productImages[0]?.url + ')'}"
                            >
                            <!-- <img
                                *ngIf="product.productImages"
                                class="title-image"
                                src="{{ product?.productImages[0]?.url }}?width=310" /> -->
                        </div>
                        <div class="title-bottom">
                            <div class="title-name">{{ product.name }} {{product['leigh']}}</div>
                            <div class="product-params">
                                <div class="product-param sq-meters">
                                    <svg-icon
                                        src="assets/images/marketplace/icon-compass-tool.svg"
                                        [svgClass]="'product-param-icon'"></svg-icon>
                                    {{ product.stockFree }}&nbsp; {{product.sellUnitName}}
                                </div>
                                <div class="elipse">&nbsp;</div>
                                <div class="product-param product-type">
                                    <svg-icon
                                        src="assets/images/marketplace/icon-kanban.svg"
                                        [svgClass]="'product-param-icon'"></svg-icon>
                                    {{ product.typeName }}
                                </div>
                                <div class="elipse">&nbsp;</div>
                                <div class="product-param product-type">
                                    <ng-container *ngIf="product.allowBreakage">Split Available</ng-container>
                                    <ng-container *ngIf="!product.allowBreakage">Sold as batch</ng-container>

                                </div>
                            </div>
                            <div class="product-price row">
                                <div class="col-7">
                                    {{ product.price | currency: 'GBP' }} <span class="tile-text-small"> per {{product.sellUnitName}}</span>
                                </div>
                                <div class="col-5 text-end">
                                    Total: {{ product.price * product.stockFree | currency: 'GBP' }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <!-- <app-pagination
            *ngIf="params.pageArray.length > 1"
            [params]="params"
            (update)="loadProducts()"></app-pagination>
 -->

            <div class="mb-3 mb-lg-5 text-center" *ngIf="totalRecords > params.limit">
                <a class="btn btn-primary" (click)="showMore()"> Show more </a>
            </div>

    </div>
</div>

<app-marketplace-filters
    *ngIf="(overlays$ | async).marketplaceFilters && minimumPrice >= 0 && maximumPrice"
    [form]="form"
    [numberOfresults]="totalRecords"
    [minimumPrice]="minimumPrice"
    [maximumPrice]="maximumPrice"></app-marketplace-filters>
